module.exports = __webpack_public_path__ + "static/media/nauta-logo.bd02a9fe.jpg";